import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
  Shipper,
  ShipperInput,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Shipper[]>({
      queryKey: ["shippers", query],
      queryFn: () => handleSearch({ baseUrl: "shippers", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (shipperInput: ShipperInput) => {
    const navigate = useNavigate();
    return useMutation<Shipper>({
      mutationFn: () =>
        handleSave({ baseUrl: "shippers", input: shipperInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Shipper>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Shipper>>({
      cacheTime: 0,
      queryKey: ["shippers", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "shippers", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Shipper>({
      cacheTime: 0,
      queryKey: ["shipper", id],
      queryFn: () => handleDetail({ baseUrl: "shippers", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Shipper>({
      mutationFn: () => handleDelete({ baseUrl: "shippers", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
